import React, { PureComponent } from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import { getPage } from "actions/page/page.functions";

import { SEO } from "components";

class PrivacyPolicy extends PureComponent {
  componentDidMount(){
    const { dispatch } = this.props;
    
    let slug = "privacy-policy";
    dispatch(getPage(slug));
  }

  render() {
    const { singlePage } = this.props;

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    return (
      <main className="view-contentpage">
        <div className="wrapper">
          <SEO {...seoProps} />
          <div className="view-contentpage__heading">
            <h1 className="u-type--beta u-type--primary">Privacy Policy</h1>
          </div>

          <div className="view-contentpage__content">
            <div className="formatted--microcopy">
              <p>
                SMS Provider Corp, trading as viahub (hereinafter referred to as
                "<strong>viahub</strong>
                ", "<strong>We</strong>
                ", "<strong>Us</strong>" and other comparable pronouns)
                considers that the User privacy is of prime importance. The User
                is urged to read the following Privacy Policy (the "
                <strong>Policy</strong>
                "), which details how We use information that We receive and
                collect from the User in relation to our website located at{" "}
                <a href="http://www.biondapp.com/">http://www.biondapp.com</a>,
                the Biond mobile applications, any updates or upgrades that are
                made available from time to time. The information is collected
                by viahub in relation to the operation of the Biond as defined
                in the Biond Terms of Service and other products provided on the
                Biond Website (together hereinafter referred to as the "
                <strong>Biond Products</strong>
                ").
              </p>

              <h2>Information that is gathered and used by viahub</h2>
              <p>
                1.1. During the installation and registration process and
                connection to the Biond Products, Biond will request that the
                User provides his/her name and his/her primary phone number. The
                User also consents to provide access to his/her address book
                (names, phone numbers, and email addresses but not any other
                personal information) stored on his/her iOS, Android or Windows
                Phone device. The user may also choose to provide Us with
                his/her age, gender, and any other additional information. All
                of the above hereinafter shall be referred to as "
                <strong>Personal Information</strong>
                ".
              </p>
              <p>
                1.2. If the User chooses not to provide any or parts of the
                Personal Information as described above, then viahub retains the
                right not to offer parts or the whole of the Biond Products to
                the User. His/her Personal Information will be stored on our
                servers, and We will use it for the following purposes:
              </p>
              <p>
                (i) to alert the User when his/her contacts start to use any of
                the Biond Products;
              </p>
              <p>
                (ii) to inform the User about which of his/her contacts are
                already Biond users;
              </p>
              <p>
                (iii) to ensure that contact information appears accurately on
                his/her device and/or on our Web platform when the User receives
                a call from another Biond user;
              </p>
              <p>
                (iv) to inform the User when a person or Biond User tries to
                make contact with him/her;
              </p>
              <p>(v) the circumstances as set out in clause 3 below</p>
              <p>
                (vi) to offer the User the option to take part in any
                promotions, surveys, questionnaires or giveaways; and
              </p>
              <p>
                (vii) to provide the User with news, updates and information in
                relation to current and new Biond Products.
              </p>
              <p>
                1.3. We shall use the User&rsquo;s phone number for
                identification purposes when the User installs and uses the
                Biond Software. Verification of the number supplied by the User
                shall be confirmed via SMS sent to his/her iOS, Android or
                Windows Phone device.
              </p>
              <p>
                1.4. The User&rsquo;s address book is stored by Us on an active
                database, which has no backup function. As such, should the User
                choose to delete the whole or any part of his/her address book,
                then it shall be entirely removed from our database and servers.
              </p>
              <p>
                1.5. A record of every call that the User makes is retained by
                viahub (which is referred to in the phone companies industry as
                a "<strong>Call Detail Record</strong>" or "<strong>CDR</strong>
                "). Every phone company retains such records as standard
                practice. Our purpose in maintaining a CDR is:
              </p>
              <p>(i) to analyse Users behaviour;</p>
              <p>
                (ii) to identify potential technical problems with Biond
                Products;
              </p>
              <p>(iii) to manage billing and related disputes; and</p>
              <p>(iv) for the protection of the general public.</p>
              <p>
                1.6. Particular CDRs may also be inspected by Us where it is
                necessary to do so in relation to a customer support and/or law
                enforcement request. All CDR data is collected in an anonymous
                fashion. CDRS are kept by Us for no longer than required by
                applicable law.
              </p>
              <p>
                1.7. Biond-to-Biond voice calls are directly connected between
                the two or more (for conference calling) Biond Users. If, for
                any reason, a direct connection cannot be established, then
                Biond servers are utilized to connect the call. No part of the
                User&rsquo;s call is ever recorded when the Biond servers are
                utilized.
              </p>
              <p>
                1.8. We may from time to time ask the User to voluntarily
                provide information by submitting a feedback form or by taking
                part in a survey. Such information is used for the purposes of
                improving the quality of Biond Products as defined in the
                Privacy Policy.
              </p>
              <h2>The ways in which Biond may use gathered information</h2>
              <p>
                2.1. During the use of the Biond Products, certain information
                may be stored by Us and used in order to deliver the best
                possible Biond Products to the User. Some of the data collected
                by Biond is used for identity verification, resolving disputes,
                providing customer support and troubleshooting purposes. We may
                also use Personal Information provided by the User that does not
                identify the User personally (such as his/her age and gender) to
                provide advertisements which We hope the User will find more
                appealing.
              </p>
              <p>
                2.2. Information as and when provided by the User that is
                typically stored by Us includes:
              </p>
              <p>
                (i) His/her Personal Information and any other necessary data
                (whether electronic or otherwise) that We use to identify the
                User when using the Biond Products;
              </p>
              <p>(ii) User profile information;</p>
              <p>
                (iii) Information that We use for billing and processing
                payments (including traffic data);
              </p>
              <p>
                (iv) Information used for payment (Bank account and credit card
                details);
              </p>
              <p>
                (v) The results of any questionnaires, surveys, or other
                feedback that the User may provide to Us;
              </p>
              <p>
                (vi) Data that is collected during the User&rsquo;s interaction
                with the Biond Products relating to his/her use of the same;
              </p>
              <p>(vii) purchased Biond Goods ;</p>
              <p>(viii) Communications between the User and Biond; and</p>
              <p>
                (ix) Biond Content ("
                <strong>Content</strong>" means any or all content consisting of
                text, stickers, sounds, pictures, photos, video and/or any type
                of information or communications, and includes location data).
              </p>

              <h2>Disclosing the User&rsquo;s Information</h2>
              <p>
                3.1. Except as provided in this section, Biond does not
                communicate or provide the User&rsquo;s Personal Information to
                any third parties. There are however certain circumstances in
                which Biond will have to disclose his/her Personal Information:
              </p>
              <p>
                (i) In order to preserve and protect our equipment used to
                provide the Biond Products and our rights (whether intellectual
                property or rights under an agreement);
              </p>
              <p>
                (ii) where there is a legal requirement to do so or where legal
                action is taken against Us; and
              </p>
              <p>
                (iii) where the personal safety of our users or members of the
                public is at risk.
              </p>
              <p>
                3.2. viahub may also share the User&rsquo;s Personal Information
                and traffic data with trusted third parties in order to provide
                the User with an optimal service. viahub ensures that our
                trusted third parties take all necessary measures to protect the
                User&rsquo;s Personal Information and traffic data and comply
                with the appropriate laws and regulations.
              </p>
              <p>
                3.3. The circumstances under which we may share the User&rsquo;s
                Personal information with trusted third parties are as follows:
              </p>
              <p>
                (i) Apple's Push Notification Service may be utilized by Us to
                alert the User when he/she misses a phone call or instant
                message. Such alerts may contain the phone number and name of
                the person who called as part of the message that the User
                receives. We send the message to Apple Inc., who delivers the
                message to the User&rsquo;s iPhone.
              </p>
              <p>
                (ii) Google's Push Notification Service may be utilized by Us to
                alert the User when he/she misses a phone call or instant
                message. Such alerts may contain the phone number and name of
                the person who called as part of the message that the User
                receives. We send the message to Google Inc., who delivers the
                message to the User&rsquo;s Android device.
              </p>
              <p>
                (iii) Microsoft Push Notification Service may be utilized by Us
                to alert the User when she/he misses a phone call or instant
                message. Such alerts may contain the phone number and name of
                the person who called as part of the message that the User
                receives. We send the message to Microsoft Corporation, who
                delivers the message to the User&rsquo;s Windows Phone device.
              </p>
              <p>
                3.4. We reserve the right to send the User messages in respect
                of faults, as well as any other service issues that may arise,
                and to use email, the Biond Products or SMS to alert the User in
                respect of any claims that relate to his/her use of the Biond
                Products.
              </p>
              <p>
                3.5. Advertisements that appear through the Biond Products will
                sometimes be provided to the User through viahub&rsquo;s
                advertising partners who may use cookies, web beacons, and/or
                other technology. Our advertising partners may also collect
                information that does not identify the User personally (such as
                recording the number of times the User views a particular
                advert) to deliver advertisements to the User. The use of such
                technology by our advertising partners is subject to their own
                privacy policies and is not covered by our Privacy Policy.
              </p>
              <h2>Children's Privacy</h2>
              <p>
                Biond does not purposefully collect or maintain Personal
                Information from Users who We know are under the age of 13. The
                Biond Products and its content are not designed to target
                potential users who are under 13 years of age.
              </p>
              <h2>No liability for Third-Party Sites</h2>
              <p>
                All internet users should be mindful when entering Personal
                Information or when using the Internet. Biond takes no
                responsibility and accepts no liability for any third party
                websites.
              </p>

              <h2>Additional features that Biond may provide</h2>
              <p>
                Biond may decide to provide additional features to the User such
                as status updates, text, and blogs (hereinafter referred to as "
                <strong>Channels</strong>
                "). Biond takes no responsibility and accepts no liability in
                any way whatsoever for the disclosure, collection, use of any
                information and Content posted on such Channels. When the User
                posts information and Content on a Channel, the User should be
                aware that any such information or Content that he/she posts is
                readily available and accessible to other users. Other users may
                also collect and use any information or Content that the User
                posts. In order to avoid receiving unwanted messages from third
                parties, the User should therefore be careful when posting any
                Personal Information and/or Content on any Channel. Biond does
                not have any power over users and other site visitors, or the
                messages they send to each other. As such, We recommend that the
                User does not post any personal or other information or Content
                that the User prefers to keep private and confidential.
              </p>

              <h2>Cookies, Clear GIFs, and your Internet Protocol Address</h2>
              <p>
                7.1. Cookies: these are pieces of information that a website
                transfers to an individual's hard drive. They enable the
                User&rsquo;s computer and browser to save information when the
                User visits the Biond Products (such as his/her User ID and
                password, for easy log in). Cookies also help to improve and
                enhance the User's experience, by, for example, tailoring the
                design and content of the Biond Products. The User&rsquo;s web
                browser should have an option to enable or disable cookies. If
                the User chooses to have cookies enabled, he/she may also choose
                to be informed and whether to accept when any particular website
                sends him/her a cookie. Similar options are available on and
                through Flash Player in relation to Flash cookies. However, if
                the User decides not to accept cookies from the Biond Products,
                this may totally or partially impair the functionality of the
                whole or parts of the Biond Products.
              </p>
              <p>
                7.2. Clear GIFS: The Biond Products and any communications sent
                to the User by Biond may also make use of clear GIFs (known also
                as "<strong>Web beacons</strong>" and "
                <strong>tracking pixels</strong>
                ") or technology of a similar nature. Clear GIFS are visible
                (but more commonly, invisible) images that are embedded in
                websites, emails and other messages and are used by Us to keep a
                record of the number of visits to the Biond Website and to let
                Us know when you have received and opened an email from Us. This
                helps Us to assess the performance of our communications to the
                User and consider how successful our marketing strategies are.
              </p>
              <p>
                7.3. The User&rsquo;s Internet Protocol Address: or "IP
                address", is the number that the User&rsquo;s Internet Service
                Provider allocates to him/her when the User goes online and/or
                surf the internet. The User&rsquo;s IP address and domain name
                may be logged by our servers when the User visits the Biond
                Products, so that We are able to easily identify the User. It
                also allows Us to improve our management of the service We
                provide to the User and identify any problems with our system.
              </p>
              <p>
                7.4. The operation of Cookies, GIFS and the User&rsquo;s IP
                address: We may use our trusted third parties to carry out the
                operation of the above technologies on our behalf. For the
                avoidance of doubt, no information regarding the User&rsquo;s
                personal identity, whatsoever, shall be collected during such
                operation.
              </p>
              <h2>Security</h2>
              <p>
                viahub makes its best efforts to ensure the protection of
                Personal Information from exploitation and loss. However, viahub
                does not warrant that the User&rsquo;s Personal Information will
                not be accessed by unauthorized third parties. We do
                nevertheless have in place various physical and electronic
                security measures (including but not limited to industry
                standard firewall and encryption security technologies) to
                protect Personal Information. Personal Information is stored on
                our servers and those of trusted third parties. Access to these
                servers is restricted to only a limited number of employees.
              </p>

              <h2>Mergers, Sales and Acquisitions</h2>
              <p>
                viahub may at any time decide to merge with, sell part or all of
                our assets to or be acquired by another company. If any such
                transactions take place, the User&rsquo;s Personal Information
                may be handed over to the buying company and/or the company We
                merge with. We shall ensure that the security of the
                User&rsquo;s Personal Information is no less than as set out
                under the terms of this Privacy Policy after such a transaction.
                No such transactions shall take place if We are in any doubt as
                to the security of the User&rsquo;s Personal Information. Once
                such a transaction has been confirmed We shall alert the User in
                respect of the same by posting a notice on the Biond Website.
              </p>

              <h2>Policy Changes</h2>
              <p>
                viahub may from time to time update or change this Policy (with
                or without giving notice to the User). The User will be able to
                view the revised Policy on the Biond Products. It is the
                User&rsquo;s responsibility to check the Biond Products for such
                changes. The User agrees that even if he/she chooses not to
                check for any changes to this Policy, by continuing to use the
                Biond Products, the User accepts and agrees to the changes and
                any revised Policy.
              </p>
              <h2> Personal and other information</h2>
              <p>
                11.1. viahub always tries to ensure that the User is able to
                access all of the information that the User provides to Us.
                Users are able to request access to, changes, updates, or to
                delete any of their information as they see fit. Information
                that users choose to delete will only be maintained by Us if it
                is necessary to do so by law or for genuine company objectives.
                However, individual Users must identify themselves and the
                information to be accessed to, changed, updated or deleted
                before viahub handles such requests. Requests should be
                submitted to our support team at{" "}
                <a href="mailto:biond-support@viahub.eu">
                  biond-support@viahub.eu
                </a>
              </p>
              <p>
                11.2. We reserve the right to refuse requests that are
                excessively frequent, necessitate prolonged sophisticated
                technical expertise and/or are significantly costly, put the
                privacy of other users at risk, or are exceptionally unfeasible.
                Deleted information may be retained on our backup servers and
                may not be fully removed for a reasonable period of time.
              </p>
              <p>
                11.3. If the User would like to access to, change, update, or
                delete any of his/her information, the User may submit a request
                by email to{" "}
                <a href="mailto:biond-support@viahub.net">
                  biond-support@viahub.eu
                </a>
              </p>
              <p>
                11.4. The User may opt not to receive emails from viahub in
                relation to news, promotions, special offers and other similar
                emails that We may send to the User from time to time by
                selecting to unsubscribe from the particular email that the User
                has received. If the User wants to remove his/her email address
                from our mailing list, the User may send Us an email at{" "}
                <a href="mailto:biond-support@viahub.eu">
                  biond-support@viahub.eu
                </a>{" "}
                with the subject UNSUBSCRIBE.
              </p>
              <p>
                11.5. If the User decides that he/she wants to permanently
                delete his/her account, he/she should contact viahub at " Biond
                Support" (available at{" "}
                <a href="http://www.maaii.com/">http://www.biondapp.com</a>) and
                submits his/her request.
              </p>
              <h2> Contacting viahub in respect of this Policy</h2>
              <p>
                If the User has any questions or queries in relation to this
                Policy, he/she may contact Us by email at{" "}
                <a href="mailto:biond-support@viahub.net">
                  biond-support@viahub.eu
                </a>
              </p>
              <h2> Use of Personal Information </h2>
              <p>
                We intend to use some of your Personal Information in direct
                marketing operations and We require your consent (which includes
                an indication of no objection) for that purpose. In this
                connection, please note that:
              </p>
              <p>(a) your name;</p>
              <p>(b) contact details;</p>
              <p>(c) products and services portfolio information.</p>
              <p>may be used by Us for direct marketing purposes.</p>
              <p>
                The following classes of services, products and subjects may be
                subject to direct marketing:
              </p>
              <p>(a) communication services such as VoIP services;</p>
              <p>(b) Biond credit;</p>
              <p>(c) Messaging products and services</p>
              <p>
                <strong>
                  By clicking this box, you give your consent to the use of your
                  Personal Information as stated above for direct marketing
                  purposes
                </strong>
              </p>
              <p>
                <strong>
                  I do not object to the use of my Personal Information as
                  described above
                </strong>
              </p>
              <p>
                <strong>
                  We may also provide your Personal Information as above to
                  other persons.
                </strong>
              </p>
              <p>
                <strong>
                  If you do not wish Us to provide to other persons your
                  Personal Information as stated above for use in direct
                  marketing as described above, you may exercise the opt-out
                  right by notifying Us in writing to the following address
                </strong>
              </p>
              <p>
                <a href="mailto:biond-support@viahub.eu">
                  biond-support@viahub.eu
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { singlePage } = state.pages;

  return {
    singlePage
  };
};

export default connect(mapStateToProps)(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/views/PrivacyPolicy.jsx